var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('v-card', {
    staticClass: "v-card--dialog v-card--dialog--sm"
  }, [_c('v-btn', {
    staticClass: "v-card--dialog__close",
    attrs: {
      "fab": "",
      "color": "transparent"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1), _c('div', {
    staticClass: "v-card--dialog__body"
  }, [_c('div', {
    staticClass: "mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("입력한 연락처로 " + _vm._s(_vm.value.amount) + " 캐시를 보내시겠습니까?")]), _c('v-divider', {
    staticClass: "grey lighten-1 mt-10px"
  })], 1), _c('div', [_c('v-row', {
    staticClass: "row--x-small font-size-14 align-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_vm._v(" 연락처 ")]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_vm._v(" " + _vm._s(_vm.value.receiver.phone) + " ")])], 1), _c('v-row', {
    staticClass: "row--x-small font-size-14 align-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_vm._v(" 보내는 금액 ")]), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_vm._v(" " + _vm._s(_vm.value.amount) + " 원 ")])], 1), _c('v-row', {
    staticClass: "row--x-small font-size-14 align-center"
  }, [_c('v-col', [_vm._v(" *정확한 연락처를 확인 후 보내시기 바랍니다. ")])], 1)], 1)]), _c('div', {
    staticClass: "v-card--dialog__foot"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.give
    }
  }, [_vm._v("확인")])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }